import { FC } from 'react';
import { GuestsPanelProps } from '../types/components';
import { Panel } from 'shared/ui/panel';

export const GuestsPanel: FC<GuestsPanelProps> = ({ children }) => {
	return <Panel>{children}</Panel>;
};
